module.exports = __webpack_public_path__ + "img/settings.bb296af0.svg";